/* eslint-disable */
import React from "react";
import { last, first } from 'lodash';
import { CalendarWeek } from '../../../controls/CalendarWeek';

export const CalendarControl2: React.FC = () => {
    
    return <CalendarWeek parameter="@crop_calendar" dictionary="calendar-origin"  />;
};
